import { axiosInstance } from '../Middleware'
import { Tenant } from './types'

export class TenantApi {
  public static loadTenant = (): Promise<Tenant[]> =>
    axiosInstance.get('/tenants')
      .then(response => (response.data as Tenant[]).filter(
        tenant => tenant.components?.some(c => c.type === 'DB')
      ))

  public static setContext = (tenantId: number, componentId: number): Promise<void> =>
    axiosInstance.put('/oauth/context', { tenant_id: tenantId, component_id: componentId })
      .then(() => undefined)
}
